import { Button, ListCard } from "@hagerty/self-service-components";
import { useState } from "react";
import clsx from "clsx";
import { PolicyDetails } from "shared";
import { useFeatureFlag, useUrls } from "../../../app/Providers/AppContext";
import { TagAction } from "../../../types/Tag.types";
import { Vehicle } from "../../Insurance/Vehicle/Vehicle";
import styles from "./VehicleListCard.module.scss";
import { mt } from "../../../utils/tracking";

const addVehicleTagAction: TagAction = {
  actionName: "Add vehicle",
  actionType: "button",
};

type VehiclesListCardProps = {
  policy: PolicyDetails;
  className?: string;
};

export const VehiclesListCard = ({
  policy,
  className,
}: VehiclesListCardProps) => {
  const [redirectAddVehicle, setRedirectAddVehicle] = useState(false);
  const { ADD_VEHICLE } = useFeatureFlag();
  const urls = useUrls();

  const { partner, policyNumber, source, vehicles, country } = policy;
  const shouldRenderAddVehicle = source === "CORE" && partner !== "state-farm";

  const addVehicleOnClick = () => {
    mt.trackAction(addVehicleTagAction);
    setRedirectAddVehicle(true);
  };

  return (
    <ListCard className={clsx(styles.listCard, className)}>
      <ListCard.Header
        aria-label={`Insured vehicles for policy ${policyNumber}`}
      >
        Insured vehicles
      </ListCard.Header>
      <ListCard.ExpandableRows
        maxRowCount={5}
        viewRowsLabel="View vehicles"
        hideRowsLabel="Hide vehicles"
        hasFooter={shouldRenderAddVehicle}
      >
        {vehicles.map((vehicle, index) => (
          <ListCard.Row key={index}>
            <Vehicle policy={policy} vehicle={vehicle} />
          </ListCard.Row>
        ))}
      </ListCard.ExpandableRows>
      {shouldRenderAddVehicle && (
        <ListCard.Footer>
          <Button
            className={styles.addVehicleButton}
            as="a"
            variant="outlined"
            size="s"
            aria-label={`Add vehicle to policy ${policyNumber}`}
            href={urls.insurance.addVehicle(
              policyNumber,
              country,
              ADD_VEHICLE.treatment
            )}
            onClick={addVehicleOnClick}
            isLoading={redirectAddVehicle}
          >
            Add vehicle
          </Button>
        </ListCard.Footer>
      )}
    </ListCard>
  );
};
